import { useState } from "react";
import "./Services.css";
import { FaArrowRight, FaArrowUp } from "react-icons/fa";
import { Container } from "react-bootstrap";
import aibg from "../../assets/images/aibg.webp";
import tailored from "../../assets/images/tailored.webp";
import responsible from "../../assets/images/responsible.webp";
import evolving from "../../assets/images/evolving.webp";


const services = [
  {
    id: 1,
    title: "AI-Driven Business Transformation",
    description:
      "Discover AI-driven opportunities across every business function for smarter operations and agile decision-making.",
    image: aibg,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 2,
    title: "Tailored Industry Solutions",
    description: "Deploy AI models designed for sector-specific challenges.",
    image: tailored,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 3,
    title: "Commitment to Responsible AI",
    description:
      "Uphold ethical AI practices with transparency, fairness, and regulatory alignment.",
    image: responsible,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 4,
    title: "Evolving AI Expertise",
    description:
      "Continuously refine AI capabilities to adapt and lead in an evolving landscape.",
    image: evolving,
    url: "/services/ai-cybersecurity",
  },
];

export default function ServicesSection() {
  const [background, setBackground] = useState(services[0].image);
  const [hovered, setHovered] = useState(null);

  const handleActivate = (service) => {
    setBackground(service.image);
    setHovered(service.id);
  };

  return (
    <Container fluid className="p-0">
      <section className="services-container">
        <h1 className="centered-title mob-title section-title">
          Strategic AI. Seamless Execution.
        </h1>
        <div
          className="services-wrapper"
          style={{ backgroundImage: `url(${background})` }}
        >
          {services.map((service) => {
            const dynamicBgColor =
              service.id % 4 === 1
                ? "rgba(25, 16, 154, 0.75)"
                : service.id % 4 === 2
                  ? "rgba(95, 12, 117, 0.75)"
                  : service.id % 4 === 3
                    ? "rgba(11, 111, 122, 0.75)"
                    : "rgba(172, 5, 5, 0.75)";

            const isActive = hovered === service.id;

            return (
              <div
                key={service.id}
                className={`service-item ${isActive ? "hovered" : ""}`}
                onMouseEnter={() => handleActivate(service)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => handleActivate(service)}
                style={{
                  background: isActive ? dynamicBgColor : "transparent",
                }}
              >
                <div className="service-content">
                  <h4 className="service-title">{service.title}</h4>
                  {isActive && (
                    <p className="service-description">
                      {service.description}
                    </p>
                  )}
                  <span className="service-icon">
                    {isActive ? (
                      <FaArrowUp className="hovered-arrow" />
                    ) : (
                      <FaArrowRight />
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </Container>
  );
}